import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

if (import.meta.env.PROD) {
	Sentry.init({
		dsn: 'https://1e9531568ec390da6f9b92e5acd9ac1e@o4509849084690432.ingest.us.sentry.io/4510049205420032',
		sendDefaultPii: true,
		release: import.meta.env.VITE_GIT_SHA || 'development',
	});
}

// Wait for vault-redirect.js to load before rendering the app
function waitForRedirect() {
	return new Promise<void>((resolve) => {
		if (window.redirectLoaded) {
			resolve();
			return;
		}

		let timeout: ReturnType<typeof setTimeout>;
		let checkInterval: ReturnType<typeof setInterval>;

		checkInterval = setInterval(() => {
			if (window.redirectLoaded) {
				clearInterval(checkInterval);
				clearTimeout(timeout);
				resolve();
			}
		}, 40);

		// Timeout after 3 seconds
		timeout = setTimeout(() => {
			clearInterval(checkInterval);
			resolve();
		}, 3000);
	});
}

waitForRedirect().then(() => {
	const rootElement = document.getElementById('root');
	if (rootElement) {
		createRoot(rootElement).render(
			<React.StrictMode>
				<App />
			</React.StrictMode>
		);
	} else {
		console.error('Root element not found');
	}
});
